import AxiosClient from "../../../services/axios.services";

class MetricEvaluationFactorServices {
  getEvaluationFactor = (params) =>
    AxiosClient.get("api/app/capacitacion_metrica_evaluacion_factor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveEvaluationFactor = (data) =>
    AxiosClient.post("api/app/capacitacion_metrica_evaluacion_factor/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEvaluationFactor = (id, data) =>
    AxiosClient.put(
      `api/app/capacitacion_metrica_evaluacion_factor/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteEvaluationFactor = (id) =>
    AxiosClient.delete(`api/app/capacitacion_metrica_evaluacion_factor/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MetricEvaluationFactorServices();
